/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import StyleguideView from "@/src/styleguide/components/StyleguideView/StyleguideView";
import OurService from "@/src/components/Sections/Generic/OurService/OurService";

export default function OurServiceStyleguide() {
  return (
    <StyleguideView fullWidth>
      <OurService />
    </StyleguideView>
  );
}
